<script>
import appConfig from '@src/app.config'
import Layout from '@layouts/main.vue'
import ThemeImg from '@src/components/shared/themeCustomiser.vue'
import menuRoutes from '@router/menuRoutes.js'

export default {
  page: {
    title: 'Home',
    meta: [{ name: 'description', content: appConfig.description }],
  },
  components: { Layout, ThemeImg },
  props: {
    user: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      routesPax: menuRoutes.navRoutePaxTotals,
    }
  },
}
</script>

<template>
  <Layout>
    <div class="icon-title">
      <div class="icon-title--icon">
        <ThemeImg style="width:120px" />
      </div>
      <h4>Kiosk Theme Customiser</h4>
    </div>
    <div style="text-align: center; margin-top: 3rem;"></div>
  </Layout>
</template>

<style lang="scss">
.icon-title {
  margin-top: 1rem;
  height: 95px;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  position: relative;
  justify-content: flex-start;
  align-items: center;
  padding: 1rem;
  .icon-title--icon {
    width: 140px;
  }
}
</style>


